// extracted by mini-css-extract-plugin
module.exports = {"btn":"ThinIconBtn_btn__La1ll","icon":"ThinIconBtn_icon__3um2S"};